export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyATPmnBdlpnQlgW8P2wY1KZL_EIG325OAA",
    authDomain: "hoxby-hub.firebaseapp.com",
    databaseURL: "https://hoxby-hub.firebaseio.com",
    projectId: "hoxby-hub",
    storageBucket: "hoxby-hub.appspot.com",
    messagingSenderId: "484221366552"
  }
};



// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/environments/environment.ts